import { render } from "./corporateContracts.html?vue&type=template&id=09556517&scoped=true&ts=true&external"
import script from "./CorporateContracts.vue?vue&type=script&lang=ts"
export * from "./CorporateContracts.vue?vue&type=script&lang=ts"

import "./CorporateContracts.vue?vue&type=style&index=0&id=09556517&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09556517"]])

export default __exports__